export const GROUP_TYPE_PAID_PLAN = 'plan';
